import { connect } from 'react-redux'
import Login from './components/Login/Login'

const mapDispatchToProps = dispatch => ({
    dispatch
})

export default connect((state) => ({ auth: state.auth }), mapDispatchToProps)(Login)
